// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanconsts.proto (package aurora.core.consts, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanconsts.proto.
 */
export const file_consts_loanconsts: GenFile = /*@__PURE__*/
  fileDesc("Chdjb25zdHMvbG9hbmNvbnN0cy5wcm90bxISYXVyb3JhLmNvcmUuY29uc3RzKp4CCg5Db250cmFjdFN0YXR1cxIHCgNORVcQABILCgdQRU5ESU5HEAESDAoIUkVKRUNURUQQAhILCgdEUk9QUEVEEAMSDAoIQ0FOQ0VMRUQQBBIICgRPUEVOEAUSCgoGQ0xPU0VEEAYSDgoKVEVSTUlOQVRFRBAHEhUKEVVOREVSX0NPUlBfQUNUSU9OEAgSEAoMUk9MTF9QRU5ESU5HEAkSIAoTQ0FOQ0VMX1JPTExfUEVORElORxD8//////////8BEiIKFUNBTkNFTF9SRVRVUk5fUEVORElORxD9//////////8BEiQKF0NBTkNFTF9ORVdfTE9BTl9QRU5ESU5HEP7//////////wESEgoFRVJST1IQ////////////ASq3AQoMUm91bmRpbmdSdWxlEgsKB1VOS05PV04QABIPCgtOT19ST1VORElORxABEhoKFlVQX1RPX05FQVJFU1RfMF9ET1RfMDEQAhIaChZVUF9UT19ORUFSRVNUXzBfRE9UXzA1EAMSGgoWVVBfVE9fTkVBUkVTVF8wX0RPVF8xMBAEEhoKFlVQX1RPX05FQVJFU1RfMF9ET1RfMjUQBRIZChVVUF9UT19ORUFSRVNUXzFfRE9UXzAQBkIpWidnaXRsYWIucHJ2YmwuY29tL2F1cm9yYS9jb3JlL3NyYy9jb25zdHNiBnByb3RvMw");

/**
 * possible states in the lifecycle of a contract
 *
 * @generated from enum aurora.core.consts.ContractStatus
 */
export enum ContractStatus {
  /**
   * @generated from enum value: NEW = 0;
   */
  NEW = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * @generated from enum value: DROPPED = 3;
   */
  DROPPED = 3,

  /**
   * @generated from enum value: CANCELED = 4;
   */
  CANCELED = 4,

  /**
   * @generated from enum value: OPEN = 5;
   */
  OPEN = 5,

  /**
   * @generated from enum value: CLOSED = 6;
   */
  CLOSED = 6,

  /**
   * @generated from enum value: TERMINATED = 7;
   */
  TERMINATED = 7,

  /**
   * @generated from enum value: UNDER_CORP_ACTION = 8;
   */
  UNDER_CORP_ACTION = 8,

  /**
   * @generated from enum value: ROLL_PENDING = 9;
   */
  ROLL_PENDING = 9,

  /**
   * @generated from enum value: CANCEL_ROLL_PENDING = -4;
   */
  CANCEL_ROLL_PENDING = -4,

  /**
   * @generated from enum value: CANCEL_RETURN_PENDING = -3;
   */
  CANCEL_RETURN_PENDING = -3,

  /**
   * @generated from enum value: CANCEL_NEW_LOAN_PENDING = -2;
   */
  CANCEL_NEW_LOAN_PENDING = -2,

  /**
   * @generated from enum value: ERROR = -1;
   */
  ERROR = -1,
}

/**
 * Describes the enum aurora.core.consts.ContractStatus.
 */
export const ContractStatusSchema: GenEnum<ContractStatus> = /*@__PURE__*/
  enumDesc(file_consts_loanconsts, 0);

/**
 * @generated from enum aurora.core.consts.RoundingRule
 */
export enum RoundingRule {
  /**
   * Unknown will be set when a value is specified that is not defined in the schema
   * and should be treated as an error.
   * NoRounding is the correct value for when there's no rounding desired.
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * No rounding is applied (other than the usual rounding to $0.0001)
   *
   * @generated from enum value: NO_ROUNDING = 1;
   */
  NO_ROUNDING = 1,

  /**
   * rounding (always UP) to the nearest $0.01
   *
   * @generated from enum value: UP_TO_NEAREST_0_DOT_01 = 2;
   */
  UP_TO_NEAREST_0_DOT_01 = 2,

  /**
   * rounding (always UP) to the nearest $0.05
   *
   * @generated from enum value: UP_TO_NEAREST_0_DOT_05 = 3;
   */
  UP_TO_NEAREST_0_DOT_05 = 3,

  /**
   * rounding (always UP) to the nearest $0.10
   *
   * @generated from enum value: UP_TO_NEAREST_0_DOT_10 = 4;
   */
  UP_TO_NEAREST_0_DOT_10 = 4,

  /**
   * rounding (always UP) to the nearest $0.25
   *
   * @generated from enum value: UP_TO_NEAREST_0_DOT_25 = 5;
   */
  UP_TO_NEAREST_0_DOT_25 = 5,

  /**
   * rounding (always UP) to the nearest $1.00
   *
   * @generated from enum value: UP_TO_NEAREST_1_DOT_0 = 6;
   */
  UP_TO_NEAREST_1_DOT_0 = 6,
}

/**
 * Describes the enum aurora.core.consts.RoundingRule.
 */
export const RoundingRuleSchema: GenEnum<RoundingRule> = /*@__PURE__*/
  enumDesc(file_consts_loanconsts, 1);

